import { commerceOfferProperties } from "@/lib/analytics-ga4";
import { trackEvent } from "@/lib/analytics";
import type { CheckoutChannel } from "@/lib/checkout-log-domain";
import type { CommerceSystem } from "@/lib/commerce-routing";

export function trackReportCheckoutStarted(props: {
  reading_id?: string;
  plan_id: string;
  price_inr: number;
  source?: string;
  placement?: string;
  checkout_channel?: string;
  commerce_system?: string;
  intent?: string;
  source_path?: string;
  customer_problem?: string;
  urgency?: string;
  confidence?: number;
  route_rank_score?: number;
  route_rank_reason?: string;
  ranked_offer_order?: string[];
  agent_trace_id?: string;
  landing_intent?: string;
  detected_intent?: string;
  intent_confidence?: string;
  is_primary_cta?: boolean;
  cta_rank?: number;
  paywall_variant?: string;
}) {
  trackEvent("report_checkout_started", props);
  trackEvent(
    "commerce_checkout_started",
    commerceOfferProperties({ ...props, offer_type: "report" })
  );
}

export function trackReportCheckoutAbandoned(props: {
  reading_id?: string;
  plan_id: string;
  price_inr: number;
  source?: string;
  placement?: string;
  intent?: string;
  source_path?: string;
  customer_problem?: string;
  route_rank_score?: number;
  route_rank_reason?: string;
  ranked_offer_order?: string[];
  agent_trace_id?: string;
  landing_intent?: string;
  detected_intent?: string;
  intent_confidence?: string;
  is_primary_cta?: boolean;
  cta_rank?: number;
  paywall_variant?: string;
}) {
  trackEvent("report_checkout_abandoned", props);
}

export function trackReportCheckoutRecovered(props: {
  reading_id?: string;
  plan_id: string;
  price_inr: number;
  source?: string;
  placement?: string;
  intent?: string;
  source_path?: string;
  customer_problem?: string;
  route_rank_score?: number;
  route_rank_reason?: string;
  ranked_offer_order?: string[];
  agent_trace_id?: string;
  landing_intent?: string;
  detected_intent?: string;
  intent_confidence?: string;
  is_primary_cta?: boolean;
  cta_rank?: number;
  paywall_variant?: string;
}) {
  trackEvent("report_checkout_recovered", props);
}

export function trackReportCheckoutRecoveryClicked(props: {
  reading_id?: string;
  plan_id?: string;
  plan_type?: string;
  source?: string;
  placement?: string;
  intent?: string;
  source_path?: string;
  recovery_channel?: string;
  recovery_order_id?: string;
}) {
  trackEvent("report_checkout_recovery_clicked", props);
}

export function trackReportPurchased(props: {
  reading_id?: string;
  plan_id: string;
  price_inr: number;
  source?: string;
  placement?: string;
  order_id: string;
  checkout_channel?: string;
  commerce_system?: string;
  intent?: string;
  source_path?: string;
  customer_problem?: string;
  urgency?: string;
  confidence?: number;
  route_rank_score?: number;
  route_rank_reason?: string;
  ranked_offer_order?: string[];
  agent_trace_id?: string;
  landing_intent?: string;
  detected_intent?: string;
  intent_confidence?: string;
  is_primary_cta?: boolean;
  cta_rank?: number;
  paywall_variant?: string;
}) {
  trackEvent("report_purchased", props);
}

export function trackRevenueCompleted(props: {
  reading_id?: string;
  revenue_inr: number;
  order_id: string;
  commerce_system: CommerceSystem;
  checkout_channel: CheckoutChannel;
  source?: string;
  source_path?: string;
  intent?: string;
  customer_problem?: string;
  urgency?: string;
  confidence?: number;
  placement?: string;
  offer_type?: string;
  plan_id?: string;
  product_sku?: string;
  product_name?: string;
  route_rank_score?: number;
  route_rank_reason?: string;
  ranked_offer_order?: string[];
  agent_trace_id?: string;
  landing_intent?: string;
  detected_intent?: string;
  intent_confidence?: string;
  is_primary_cta?: boolean;
  cta_rank?: number;
  paywall_variant?: string;
}) {
  trackEvent("revenue_completed", props);
  trackEvent(
    "commerce_purchase_completed",
    commerceOfferProperties({ ...props, offer_type: props.offer_type ?? "report" })
  );
}
